import { useMobile } from '../../../../../../../../common/services/screenSize/ScreenSizeService';
import {
  Header,
  Text,
} from '../../../DentalPricing/DentalPricingTooltip/DentalPricingTooltip.styles';

export const DentalPricingGapFreeTooltip = () => {
  const isMobile = useMobile();
  return (
    <>
      {isMobile && <Header>Gap free check-up and clean</Header>}
      <Text>
        This practice is a preferred provider of one or more health funds offering a gap free
        check-up and clean. To understand your coverage, contact your health fund.
      </Text>
    </>
  );
};
